window.require = require

window.whereToBuyScript = document.currentScript.src

let tri = window.tri = require('tripartite')

let ProductSearch = require('./product-search')

let productSearch = new ProductSearch()

window.addEventListener('load', () => {
	productSearch.init()
})



